export enum ZonesListFilterKeys {
  selectedWarehouseId = 'selectedWarehouseId',
  zoneType = 'zoneType',
}
